<div
    role="group"
    class="agpr-formField"
    [ngClass]="{
        'agpr-imageStyleField-container': field.isPrimary,
        'agpr-imageStyleField-subContainer': !field.isPrimary
    }"
    [attr.aria-label]="field.label | localize"
>
    <div
        [ngClass]="{
            'agpr-formField-heading': field.isPrimary,
            'agpr-formField-subheading': !field.isPrimary
        }"
    >
        <span class="agpr-formField-headingLabel">
            {{ field.label | localize }}
        </span>
        @if (field.isPrimary) {
            <div class="agpr-formField-headingButtons">
                @if(field.allowExpertMode) {
                    <agpr-button
                        class="agpr-formField-headingButton"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-code"
                        tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                        tooltipPosition="top"
                        (click)="saveExpertTemplate()"
                    ></agpr-button>
                }
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-floppy-disk"
                    tooltip="PageBuilder.formField.tooltip.saveStyle"
                    tooltipPosition="top"
                    (click)="saveStyle()"
                ></agpr-button>
        </div>
        }
    </div>

    @if (field.showStyleState) {
        <div class="agpr-imageStyleField-styleState">
            <div class="agpr-inputGroupRow">
                <div class="agpr-inputGroupRow-dropdown">
                    <agpr-dropdown-field
                        [id]="id + '_styleStateDropdown'"
                        [value]="value.displayStyleState"
                        [field]="styleStateField"
                        [updateOptions]="styleStateField.options"
                        [labelClass]="'agpr-dropdown-label--semibold'"
                        (changes)="setStyle($event, styleStateField.property)"
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-inputGroupRow-buttons">
                    <agpr-button
                        icon="fa-regular fa-duotone fa-gear"
                        [id]="id + '_manageStyles'"
                        [style]="buttonTypes.block"
                        tooltip="PageBuilder.formField.tooltip.manageStyles"
                        tooltipPosition="top"
                        (click)="manageStylesButtonClicked()"
                    ></agpr-button>
                </div>
            </div>
        </div>
    }

    @if (!value.template) {
        <div
            role="radiogroup"
            class="agpr-imageStyleField-imageAlignment"
            [attr.aria-label]="'PageBuilder.formField.tooltip.alignment' | localize"
        >
            <agpr-radio
                class="agpr-imageStyleField-button"
                [id]="id + '.objectLeftRadioButton'"
                name="objectAlignment-{{id}}"
                [value]="fontAlignmentEnum.left"
                [style]="radioTypesEnum.button"
                [icon]="'fa-regular fa-duotone fa-objects-align-left'"
                [iconTooltip]="'PageBuilder.formField.tooltip.alignImageLeft'"
                tooltipPosition="top"
                hiddenLabel="PageBuilder.formField.tooltip.alignImageLeft"
                [(ngModel)]="value.imageAlignment"
                (onClick)="setStyle(fontAlignmentEnum.left, 'imageAlignment')"
            ></agpr-radio>
            <agpr-radio
                class="agpr-imageStyleField-button"
                [id]="id + '.objectCenterRadioButton'"
                name="objectAlignment-{{id}}"
                [value]="fontAlignmentEnum.center"
                [style]="radioTypesEnum.button"
                [icon]="'fa-regular fa-duotone fa-objects-align-center-horizontal'"
                [iconTooltip]="'PageBuilder.formField.tooltip.alignImageCenter'"
                tooltipPosition="top"
                hiddenLabel="PageBuilder.formField.tooltip.alignImageCenter"
                [(ngModel)]="value.imageAlignment"
                (onClick)="setStyle(fontAlignmentEnum.center, 'imageAlignment')"
            ></agpr-radio>
            <agpr-radio
                class="agpr-imageStyleField-button"
                [id]="id + '.objectRightRadioButton'"
                name="objectAlignment-{{id}}"
                [value]="fontAlignmentEnum.right"
                [style]="radioTypesEnum.button"
                [icon]="'fa-regular fa-duotone fa-objects-align-right'"
                [iconTooltip]="'PageBuilder.formField.tooltip.alignImageRight'"
                tooltipPosition="top"
                hiddenLabel="PageBuilder.formField.tooltip.alignImageRight"
                [(ngModel)]="value.imageAlignment"
                (onClick)="setStyle(fontAlignmentEnum.right, 'imageAlignment')"
            ></agpr-radio>
        </div>

        <div class="agpr-imageStyleField-fieldRow">
            <div class="agpr-imageStyleField-fieldRow-item">
                <agpr-color-picker-field
                    [id]="id + '_backgroundColorPicker'"
                    [field]="backgroundColorField"
                    [value]="value.backgroundColor"
                    (changes)="setStyle($event, backgroundColorField.property)"
                ></agpr-color-picker-field>
            </div>
        </div>

        <div
            class="agpr-imageStyleField"
            [ngClass]="{
                'agpr-imageStyleField-content': field.isPrimary,
                'agpr-imageStyleField-subContent': !field.isPrimary
            }"
        >
            <div class="agpr-formField-subheading">
                <span class="agpr-formField-headingLabelSmall">
                    {{ "Briefing.textStyle.caption.label" | localize }}
                </span>
            </div>
            <div class="agpr-imageStyleField-fieldRow">
                <div class="agpr-imageStyleField-fieldRow-item">
                    <agpr-dropdown-field
                        class="agpr-imageStyleField-font"
                        [id]="id + '.fontFamilyDropdown'"
                        [value]="value.fontFamily"
                        [field]="fontFamilyField"
                        inputTooltip="PageBuilder.formField.tooltip.captionFont"
                        (changes)="setStyle($event, fontFamilyField.property)"
                    ></agpr-dropdown-field>
                </div>

                <div class="agpr-imageStyleField-textFormattingButtons">
                    <agpr-checkbox
                        class="agpr-imageStyleField-button"
                        [id]="'imageStyleField_bold'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-bold"
                        tooltip="PageBuilder.formField.tooltip.bold"
                        [(ngModel)]="value.bold"
                        (onChange)="setStyle($event, 'bold')"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-imageStyleField-button"
                        id="imageStyleField_italics"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-italic"
                        tooltip="PageBuilder.formField.tooltip.italics"
                        [(ngModel)]="value.italics"
                        (onChange)="setStyle($event, 'italics')"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-imageStyleField-button"
                        id="imageStyleField_underline"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-underline"
                        tooltip="PageBuilder.formField.tooltip.underline"
                        [(ngModel)]="value.underlined"
                        (onChange)="setStyle($event, 'underlined')"
                    ></agpr-checkbox>
                </div>
            </div>

            <div class="agpr-imageStyleField-fieldRow">
                @if (field.showFontSizeDropdown) {
                    <div
                        class="agpr-imageStyleField-fontSize"
                        [pTooltip]="'PageBuilder.formField.tooltip.captionSize' | localize"
                    >
                        <div class="agpr-imageStyleField-fontSizeIcon">
                            <span class="agpr-i-font-size" aria-hidden="true"></span>
                        </div>
                        <agpr-dropdown-field
                            class="agpr-imageStyleField-fontSizeDropdown"
                            [id]="id + '.fontSizeDropdown'"
                            [value]="value.fontSize"
                            [field]="fontSizeField"
                            (changes)="setStyle($event, fontSizeField.property)"
                        ></agpr-dropdown-field>
                    </div>
                }

                @if (field.showAlignmentButtons) {
                    <div
                        role="radiogroup"
                        class="agpr-imageStyleField-fontAlignmentButtons"
                        [attr.aria-label]="'PageBuilder.formField.tooltip.fontAlignment' | localize"
                    >
                        <agpr-radio
                            class="agpr-imageStyleField-button"
                            [id]="id + '.textLeftRadioButton'"
                            name="fontAlignment-{{id}}"
                            [value]="fontAlignmentEnum.left"
                            [(ngModel)]="value.alignment"
                            [iconTooltip]="'PageBuilder.formField.tooltip.alignLeft'"
                            tooltipPosition="top"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-align-left'"
                            (onClick)="setStyle(fontAlignmentEnum.left, 'alignment')"
                            hiddenLabel="PageBuilder.formField.tooltip.alignTextLeft"
                        ></agpr-radio>
                        <agpr-radio
                            class="agpr-imageStyleField-button"
                            [id]="id + '.textCenterRadioButton'"
                            name="fontAlignment-{{id}}"
                            [value]="fontAlignmentEnum.center"
                            [(ngModel)]="value.alignment"
                            [iconTooltip]="'PageBuilder.formField.tooltip.alignCenter'"
                            tooltipPosition="top"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-align-center'"
                            (onClick)="setStyle(fontAlignmentEnum.center, 'alignment')"
                            hiddenLabel="PageBuilder.formField.tooltip.alignTextCenter"
                        ></agpr-radio>
                        <agpr-radio
                            class="agpr-imageStyleField-button"
                            [id]="id + '.textRightRadioButton'"
                            name="fontAlignment-{{id}}"
                            [value]="fontAlignmentEnum.right"
                            [(ngModel)]="value.alignment"
                            [iconTooltip]="'PageBuilder.formField.tooltip.alignRight'"
                            tooltipPosition="top"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-align-right'"
                            (onClick)="setStyle(fontAlignmentEnum.right, 'alignment')"
                            hiddenLabel="PageBuilder.formField.tooltip.alignTextRight"
                        ></agpr-radio>
                    </div>
                }
            </div>

            <div class="agpr-imageStyleField-fieldRow">
                <div class="agpr-imageStyleField-fieldRow-item">
                    <agpr-color-picker-field
                        [id]="id + '_textColorPicker'"
                        [field]="colorPickerField"
                        [value]="value.color"
                        (changes)="setStyle($event, colorPickerField.property)"
                    ></agpr-color-picker-field>

                </div>
                <!-- Placeholder element to preserve two-column layout -->
                <div class="agpr-imageStyleField-fieldRow-item"></div>
            </div>
        </div>

        @if (showCornerRadius) {
            <agpr-corner-radius
                class="agpr-imageStyleField-cornerRadius"
                [id]="id + '_corner_radius'"
                [(cornerRadius)]="value.cornerRadius"
                (cornerRadiusChanged)="setStyle($event, 'cornerRadius')"
            ></agpr-corner-radius>
        }

        <agpr-block-padding
            class="agpr-imageStyleField-blockPadding"
            [id]="id + '_padding'"
            [(padding)]="value.padding"
            (paddingChanged)="setStyle($event, 'padding')"
        ></agpr-block-padding>

        @if (field.showDoBorder) {
            <div class="agpr-imageStyleField-doBorder" [class.agpr-imageStyleField-doBorder--expanded]="value.doBorder">
                <agpr-checkbox
                    [id]="'imageStyleField_doBorder'"
                    [binary]="true"
                    label="PageBuilder.formField.styles.doBorder"
                    labelStyleClass="agpr-imageStyleField-doBorder-label"
                    [(ngModel)]="value.doBorder"
                    (onChange)="setStyle($event, 'doBorder')"
                ></agpr-checkbox>
                @if (value.doBorder) {
                    <div class="agpr-imageStyleField-fieldRow">
                        <div class="agpr-imageStyleField-fieldRow-item">
                            <agpr-color-picker-field
                                [id]="id + '_borderColorPicker'"
                                [field]="borderColorField"
                                [value]="value.borderColor"
                                (changes)="setStyle($event, borderColorField.property)"
                            ></agpr-color-picker-field>
                        </div>
                        <div class="agpr-imageStyleField-fieldRow-item">
                            <agpr-number-input
                                [id]="id + '_borderWidth'"
                                label="PageBuilder.formField.styles.borderWidth"
                                unit="px"
                                [bottomMargin]="false"
                                [integerOnly]="true"
                                [min]="0"
                                [max]="100"
                                [(ngModel)]="value.borderWidth"
                                (blur)="setStyle(value.borderWidth, 'borderWidth')"
                            ></agpr-number-input>
                        </div>
                    </div>
                }
            </div>
        }
    } @else {
        <div class="agpr-imageStyleField">
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ "PageBuilder.styles.expertStyleAppliedPreMessage" | localize }}
                <span style="font-weight: bold">
                    {{ field.label | localize }}
                </span>
                {{ "PageBuilder.styles.expertStyleAppliedPostMessage" | localize }}
            </agpr-message>
        </div>
    }
</div>
